import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as SiteManager from '../domain/site-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { PromiseType } from '../../types/general';
// import { useSelector } from 'react-redux';
// import { Selectors } from '../../selectors';

type ContextState = Data<TrendChannels>;
type TrendChannels = PromiseType<ReturnType<typeof SiteManager.getTrendChannels>>;

const Context = React.createContext<ContextState | null>(null);

function useTrendChannels(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useTrendChannels must be used within a TrendChannelsProvider');
    }
    return contextState;
}

const TrendChannelsProvider: React.FC<{ deviceId: string }> = (props) => {
    const authHelper = useAuthHelper();

    const { dataset } = useData({
        cacheKey: 'trend-channels',
        id: `${props.deviceId}`,
        dataFn: React.useCallback(
            (): Promise<TrendChannels> => SiteManager.getTrendChannels(authHelper, props.deviceId),
            [props.deviceId, authHelper]
        ),
    });

    return <Context.Provider value={dataFromDataset(dataset)}>{props.children}</Context.Provider>;
};

const TestTrendChannelsProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { TrendChannelsProvider, TestTrendChannelsProvider, useTrendChannels };
